import volumes from './volumes';
import targetGroups from './targetGroups';
import targets from './targets';
import luns from './luns';
import users from './users';
import initiators from './initiators';
import nodes from './nodes';
import nodeTargets from './nodeTargets';
import nodeLuns from './nodeLuns';

export default {
  namespaced: true,
  modules: {
    volumes,
    targetGroups,
    targets,
    luns,
    users,
    initiators,
    nodes,
    nodeTargets,
    nodeLuns
  }
};
